export default {
  namespaced: true,
  state: {
    internationalAirTicketServiceGroupId: '', // 国际机票在线询价客服组id
  },
  mutations: {
    setInternationalAirTicketCustomerServiceTeam(state, data) {
      state.internationalAirTicketServiceGroupId = data;
    },
  },
  actions: {},
};
